var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38095 0.549438C1.06599 0.549438 0 1.61543 0 2.93039V25.5494C0 39.3566 11.1929 50.5494 25 50.5494C38.8071 50.5494 50 39.3566 50 25.5494C50 11.7423 38.8071 0.549438 25 0.549438H2.38095ZM15.3427 14.5494H32.6122C33.9187 14.5494 35 15.6237 35 16.9218V29.3655C35 30.6635 33.9187 31.7378 32.6122 31.7378H28.0475V35.6768C28.0475 36.4378 27.1014 36.8406 26.5608 36.3035L21.7852 31.7378H15.3878C14.0813 31.7378 13 30.6635 13 29.3655V16.9218C13 15.6237 14.0362 14.5494 15.3427 14.5494Z",
    fill: "#F3F0E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolChat);
export default __webpack_public_path__ + "static/media/symbol-chat.b427fe4810bc0d563b3f4f677f244253.svg";
export { ForwardRef as ReactComponent };